/**
 * Card Image Size Enum
 */
export var CardImageSize;
(function (CardImageSize) {
    CardImageSize[CardImageSize["SIZE_1"] = 1] = "SIZE_1";
    CardImageSize[CardImageSize["SIZE_2"] = 2] = "SIZE_2";
    CardImageSize[CardImageSize["SIZE_3"] = 3] = "SIZE_3";
    CardImageSize[CardImageSize["SIZE_4"] = 4] = "SIZE_4";
})(CardImageSize || (CardImageSize = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ2FyZEltYWdlRW51bS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL2NvbXBvbmVudHMvY2FyZC9pbWFnZS9DYXJkSW1hZ2VFbnVtLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOztHQUVHO0FBQ0gsTUFBTSxDQUFOLElBQVksYUFLWDtBQUxELFdBQVksYUFBYTtJQUN2QixxREFBVSxDQUFBO0lBQ1YscURBQVUsQ0FBQTtJQUNWLHFEQUFVLENBQUE7SUFDVixxREFBVSxDQUFBO0FBQ1osQ0FBQyxFQUxXLGFBQWEsS0FBYixhQUFhLFFBS3hCIn0=